var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 22",
    fill: "none",
    stroke: "#A0072B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 3,
    r: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5V14C2.5 14.5523 2.05228 15 1.5 15V15C0.947715 15 0.5 14.5523 0.5 14V9.5C0.5 7.84315 1.84315 6.5 3.5 6.5H6.5C8.15685 6.5 9.5 7.84315 9.5 9.5V14C9.5 14.5523 9.05228 15 8.5 15V15C7.94772 15 7.5 14.5523 7.5 14V10V20.25C7.5 20.9404 6.94036 21.5 6.25 21.5V21.5C5.55964 21.5 5 20.9404 5 20.25V15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5V20.25C2.5 20.9404 3.05964 21.5 3.75 21.5V21.5C4.44036 21.5 5 20.9404 5 20.25V15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.a8b1d4214ac3a3e49b17cf2c0599611f.svg";
export { ForwardRef as ReactComponent };